import { FC } from 'react';
import { Typography } from '@mui/material';

import { Modal } from '@shared/components/modals/Modal';
import { ILeadNoAssetAssignedModalProps } from '../interfaces';

export const LeadNoAssetAssignedDataModal: FC<ILeadNoAssetAssignedModalProps> = ({ handleClose, messageText }) => {
  return (
    <Modal
      open
      title="Lead-Asset Mapping"
      dialogWidth="650px"
      onClose={handleClose}
    >
      <Typography
        justifyContent="center"
        variant="h3"
        mb={2}
      >
        {messageText}
      </Typography>
    </Modal>
  );
};
